import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/link.svg';

export const IconLink = createIconComponent(Icon);
